import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { NonceUtility } from '@jms/model';
import { AuthTokenService } from '@jms/utils/util.authentication';
import { ConfigService } from '@jms/ui/ui.standalone.services/config.service';
import { DurableAgentTransport } from './durable.agent.transport';

/**
 * The injectable durable transport: HttpClient for the JSON routes (its interceptors add the pass
 * and the nonce), `fetch` with the same pass and a fresh nonce for the long-lived subscribe read.
 */
@Injectable({ providedIn: 'root' })
export class DurableAgentTransportService extends DurableAgentTransport {

  constructor() {

    const http = inject(HttpClient);
    const authTokenService = inject(AuthTokenService);
    super({
      http,
      getAuthToken: async () => (await authTokenService.getValidToken()) ?? '',
      fetchImpl: (input, init) => fetch(input, init),
      // Raw fetch bypasses the HTTP interceptors, so the nonce the tenant API requires is added here.
      nonce: () => NonceUtility.tryGenerate(ConfigService.environment.tenant, window.location.hostname, ConfigService.environment.nonce) ?? undefined,
    });
  }
}
